<template>

  <group-card title="Other Incomes" icon="attach_money" :tooltipText="tooltipText" tooltipMinWidth="200">
    <div class="boxed-category">
    <!-- Income array inputs -->
    <!-- <transition-group v-bind="transitions.expand" v-on="transitions.expand"> -->
      <div class="md-layout input-layout"
        v-for="(income, index) in applicant.incomes"
        :key="id(income)"
        >

        <!-- Type -->
        <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-20"
          label="Type" v-model="income.type"
          :options="options.income_type"
          :prefixLabel="prefixLabel + ' ' + (index+1)"
          required
          force
        />

        <!-- Amount -->
        <validated-input
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-20"
          label="Amount"
          :prefixLabel="prefixLabel + ' ' + (index+1)"
          prefix="$"
          v-model="income.amount"
          :suffix="toMonthlyAmount(income.amount, income.frequency, true) + '/m'"
        />

        <!-- Frequency -->
        <validated-autocomplete-input class="md-layout-item md-small-size-100 md-size-20"
          label="Frequency" v-model="income.frequency"
          :prefixLabel="prefixLabel + ' ' + (index+1)"
          :options="options.payment_frequency_options"
          force
        />

        <!-- remove button -->
        <div class="md-layout-item md-size-40 text-right">
          <md-button class="md-primary md-simple md-danger md-just-icon" @click="arrayRemove(applicant.incomes, income)"><md-icon>close</md-icon></md-button>
        </div>

      </div>
    <!-- </transition-group> -->

    <div class="md-layout">

      <!-- Add -->
      <div class="md-layout-item">
        <md-button class="md-primary md-sm" @click="addListItem">Add</md-button>
      </div>

    </div>
    </div>
  </group-card>

</template>

<script>
import { mapGetters } from 'vuex';
import filters from '@/components/utils/filters';
import utils from '@/components/utils/utils';
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import { newIncome } from "@/schema.js";
import transitions from "@/components/utils/transitions";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
  },
  data(){
    return {
      transitions,
      tooltipText: '<p>Income needs to be taxable income</p>'+
                   '<li>Secondary Employment</li>'+
                   '<li>Government Benefits</li>'+
                   '<li>Child Support</li>',
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: 'Income',
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: 'options',
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get(){ return this.value },
      set(applicant){ this.$emit('input', applicant) },
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    addListItem(){
      this.applicant.incomes.push(newIncome());
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'income_type',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
